// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable max-classes-per-file */
export class DuplicateException extends Error {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  response: {status: number; data: {message: any}};

  constructor(message) {
    super(message);
    this.name = 'DuplicateException';
    this.response = {
      status: 409,
      data: {
        message,
      },
    };
  }
}

export class InvalidResponse extends Error {
  response: {status: number};

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;

  constructor(error) {
    super();
    this.name = 'InvalidResponse';
    this.message = typeof error === 'object' ? JSON.stringify(error) : error;
    this.response = {
      status: 0,
    };
    this.error = error;
  }
}

export class InvalidErrorObject extends Error {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;

  constructor(message, error) {
    super(message);
    this.name = `InvalidErrorObject - ${message}`;
    this.message = typeof error === 'object' ? JSON.stringify(error) : error;
    this.error = error;
  }
}
